import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import {IMyDpOptions} from 'mydatepicker';
import * as moment from 'moment';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';

@Component({
	selector: 'app-billing',
	templateUrl: './billing.component.html',
	styleUrls: []
})

export class BillingComponent implements OnInit {

	private toasterService: ToasterService;
    companyId: any;
    startDate: any;
    endDate: any;
    guardCountBulkData: any;
    _location: any;
    dataToShow :any = [];
    public startDatePickerOptions: IMyDpOptions = {
        showClearDateBtn: false,
        dateFormat: 'mmm, dd yyyy',
    };

    public endDatePickerOptions: IMyDpOptions = {
        showClearDateBtn: false,
        dateFormat: 'mmm, dd yyyy',
    };

	constructor(private apiService: ApiService, toasterService: ToasterService, private route: ActivatedRoute, private router: Router, _location: Location) {
        this.toasterService = toasterService;
        this._location = _location;
	}

	ngOnInit() {

		if(! sessionStorage.getItem('access_token_nv_admin')) {
			window.open("/login", "_self");
        }
        this.route.params.subscribe(params => {      
            this.companyId = params['id'];
            this.startDate = moment(params['startDate']).toObject();
            this.startDate = { date: { year: this.startDate.years, month: this.startDate.months+1, day: this.startDate.date } };
            this.endDate = moment(params['endDate']).toObject();
            this.endDate = { date: { year: this.endDate.years, month: this.endDate.months+1, day: this.endDate.date } };
            this.endDatePickerOptions = {
                showClearDateBtn: false,
                dateFormat: 'mmm, dd yyyy',
                disableUntil: this.startDate.date
            };
            this.startDatePickerOptions = {
                showClearDateBtn: false,
                dateFormat: 'mmm, dd yyyy',
                disableSince: this.endDate.date
            };
        });
        this.getActiveGuardCountsBulk();
    }

    getActiveGuardCountsBulk() {
        var startDate = JSON.parse(JSON.stringify(this.startDate));
        var endDate = JSON.parse(JSON.stringify(this.endDate));
        startDate.date.month--;
        endDate.date.month--;
        this.apiService.getActiveGuardCountsBulk(this.companyId, moment(startDate.date).format('YYYY-MM-DD'), moment(endDate.date).format('YYYY-MM-DD')).subscribe((data:any) =>{
			this.guardCountBulkData = [data];
		},
		error => {
			if (error.statusText == "Unauthorized") {
				// this.toasterService.pop('error', 'Session Expired', 'Please login again');
				window.open("/logout", "_self");
			} else
				 this.toasterService.pop('error', error.error.message);
		});
    }
    downloadPdf(index) {
        var doc = new jsPDF();
        
        this.dataToShow = this.guardCountBulkData[0].dateRange;

        var dataToAdd = [];
        this.dataToShow.forEach( item => {
            dataToAdd.push([moment(item.date.split('T'[0])).format('LL'), item.guardCount,item.managerCount, item.variableUserCounts]);
        });

        doc.fromHTML('<b>Company Name:</b> ' + this.guardCountBulkData[0].companyDetails.name, 10, 10);
        doc.fromHTML('<b>From:</b> ' + moment(this.guardCountBulkData[0].startDate.split('T')[0]).format('LL') + '     <b>To:</b> ' + moment(this.guardCountBulkData[0].endDate.split('T')[0]).format('LL'), 10, 17);
        doc.fromHTML('<b>Fixed Active Users Count:</b> '+ this.guardCountBulkData[0].companyDetails.activeUsersCount, 10, 24);
        doc.fromHTML('<b>Total Variable Active Users:</b> '+ this.guardCountBulkData[0].totalVariableUserCount, 10, 31);
        
        doc.autoTable({
            margin: {top: 41},
            head: [['Date', 'TOTAL ACTIVE STAFF','TOTAL ACTIVE MANAGER', 'VARIABLE ACTIVE USERS']],
            body: dataToAdd
        });
        doc.save('Bill_' + this.guardCountBulkData[0].startDate.split('T')[0] + '_' + this.guardCountBulkData[0].endDate.split('T')[0]);
    }

    onStartDateChanged(event:any) {
		this.endDatePickerOptions = {
			showClearDateBtn: false,
			dateFormat: 'mmm, dd yyyy',
			disableUntil: event.date
		};
	}

	onEndDateChanged(event:any) {
		this.startDatePickerOptions = {
			showClearDateBtn: false,
			dateFormat: 'mmm, dd yyyy',
			disableSince: event.date
		};
    }
    
    backClicked() {
        this._location.back();
    }

    convertDateToString(dateToBeConverted: string) {
		return moment(dateToBeConverted, "YYYY-MM-DD HH:mm:ss").format("LL");
	}

}



// WEBPACK FOOTER //
// ./src/app/components/billing/billing.component.ts